const images = {
  closeIcon: './assets/images/close.svg',
  logoSymbol: './assets/images/logo_symbol.png',
  logo: './assets/images/logo.png',
  viewerDefaultThumb: './assets/images/viewer_default_thumb.png',
  playerCredit: './assets/images/logo-horz-grey.png',
  helpCenter: './assets/images/help_center.png',
  poweredBy: './assets/images/powered_by_oneroom_white.png',
  eventCoverDefault: './assets/images/placeholder_portrait.jpg',
  profileThumbDefault: './assets/images/profile_thumb_default.png',
  camThumbDefault: './assets/images/cam_thumb_default.png',
  camIcon: './assets/images/video_white.png',
  loading: './assets/images/loading_drop.gif',
  notificationIcon: './assets/images/notification-icon.png',
  customMessageIcon: './assets/images/notification-icon.svg',
  noSoundIcon: './assets/images/nosound.svg',
  errorIcon: './assets/images/error.svg',
  feedbackIcon: './assets/images/feedback.svg',
  thankIcon: './assets/images/thank-icon.png',
  oneroomLogo: './assets/images/oneroom-logo.png',
  preNeedBanner: './assets/images/preNeedBanner.png',
  preNeedMobileBanner: './assets/images/preNeedBannerMobile.png',
  hug: './assets/images/hug.svg',
  donate: './assets/images/donate.svg',
  donation: './assets/images/donation.svg',
  gift: './assets/images/gift.svg',
  flower: './assets/images/flower.svg',
  tribute: './assets/images/tribute.svg',
  greifSupport: './assets/images/greifsupport.svg',
  communityEvent: './assets/images/communityevent.svg',
  prePlanning: './assets/images/preplanning.svg',
  tributeblanket: './assets/images/tributeblanket.svg',
  tree: './assets/images/tree.svg',
};

export default images;
